import { Edit2, Trash2 } from "lucide-react";

/**
 * ActionButtons Components
 *
 * Reusable button components untuk action Edit dan Delete
 * dengan desain yang konsisten di seluruh aplikasi
 */

/**
 * EditButton Component
 * @param {Function} onClick - Handler ketika tombol diklik
 * @param {string} title - Tooltip text (default: "Edit")
 * @param {number} size - Ukuran icon (default: 18)
 */
export function EditButton({ onClick, title = "Edit", size = 18 }) {
  return (
    <button
      onClick={onClick}
      className="p-2 bg-blue-100 text-blue-600 rounded-lg hover:bg-blue-200 transition-colors"
      title={title}
    >
      <Edit2 size={size} />
    </button>
  );
}

/**
 * DeleteButton Component
 * @param {Function} onClick - Handler ketika tombol diklik
 * @param {string} title - Tooltip text (default: "Hapus")
 * @param {number} size - Ukuran icon (default: 18)
 */
export function DeleteButton({ onClick, title = "Hapus", size = 18 }) {
  return (
    <button
      onClick={onClick}
      className="p-2 bg-red-100 text-red-600 rounded-lg hover:bg-red-200 transition-colors"
      title={title}
    >
      <Trash2 size={size} />
    </button>
  );
}
